export default "__VITE_ASSET__z1_KJ$bh__"